import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="w-full bg-slate-900 text-slate-400 py-12 px-4 text-center text-sm" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <p className="mb-4" data-id="element-84">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="mb-4" data-id="element-85">
          Los resultados pueden variar. La información proporcionada en este
          producto es con fines educativos y no reemplaza la instrucción formal
          académica ni los protocolos específicos de cada institución
          hospitalaria.
        </p>
        <div className="flex justify-center gap-4 mt-8" data-id="element-86">
          <a href="#" className="hover:text-white transition-colors" data-id="element-87">
            Términos y Condiciones
          </a>
          <span data-id="element-88">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-89">
            Políticas de Privacidad
          </a>
        </div>
        <p className="mt-8 text-slate-500" data-id="element-90">
          © {new Date().getFullYear()} EbookDreamShop. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
};